
(function() {
  var result = { translations: { "es": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Acciones" }, "tag": { "remove": "Eliminar etiqueta" }, "Select": { "noResults": "No se encontraron resultados", "searchPlaceholder": "Buscar...", "clearSelections": "Borrar selecciones" }, "ErrorMessage": { "error": { "title": "No encontramos lo que buscas." }, "notFound": { "title": "No todos los que deambulan est\xE1n perdidos." }, "badRequest": { "title": "Se produjo un problema al cargar esta p\xE1gina." }, "expired": { "title": "Lo sentimos." }, "sessionId": { "prefix": "ID de la sesi\xF3n: " } }, "ProgressSteps": { "completedStep": "Paso completado", "incompleteStep": "Paso incompleto" }, "Paginator": { "label": "Paginaci\xF3n", "pageNumber": { "currentIndicator": "Est\xE1s actualmente en", "description": "P\xE1gina " }, "firstPage": { "label": "Primero", "description": "Primera p\xE1gina" }, "previousPage": { "label": "Anterior", "description": "P\xE1gina anterior" }, "nextPage": { "label": "Siguiente", "description": "P\xE1gina siguiente" }, "lastPage": { "label": "\xDAltima", "description": "\xDAltima p\xE1gina" } }, "Datagrid": { "noData": { "Title": "No hay datos disponibles", "Description": "No hay datos disponibles para mostrar." }, "noResults": { "Title": "No se encontraron resultados", "Description": "Prueba ajustando la b\xFAsqueda y los filtros para encontrar lo que est\xE1s buscando.", "ClearActionLabel": "Borrar b\xFAsqueda y filtros" }, "toolbar": { "selectedRows": { "one": "{{count}} fila seleccionada", "other": "{{count}} de filas seleccionadas", "clearSelection": "Borrar selecci\xF3n", "selectAll": "Seleccionar las {{totalRows}} filas" }, "search": { "placeholder": "Buscar", "label": "Buscar", "clearSearch": "Borrar b\xFAsqueda" } }, "pagination": { "visibleRows": "{{visibleRows}} de {{totalRows}} resultados", "itemsPerPage": "Elementos por p\xE1gina", "countPerPage": { "one": "{{count}} por p\xE1gina", "other": "{{count}} por p\xE1gina", "many": "{{count}} por p\xE1gina" } }, "SkeletonGrid": { "loading": "Cargando" }, "DataGridColumnManagementPanel": { "description": "Elige las propiedades que se mostrar\xE1n como columnas. A continuaci\xF3n, desplaza hacia arriba o hacia abajo o arrastra y suelta las propiedades para cambiar el orden en el que se mostrar\xE1n.", "removeAllColumns": "Eliminar todas las columnas", "update": "Actualizar", "cancel": "Cancelar", "edit": "Editar columnas" } } }, "ui": { "UIAbstractPageSection": { "page": "Secci\xF3n de la p\xE1gina" }, "UICarousel": { "current": "Mostrando elemento {{currentStepDisplayNumber}} de {{totalSteps}}", "prev": "Anterior", "next": "Siguiente", "tip": "Utiliza las teclas de flecha para ver otros elementos" }, "UIColorSwatch": { "label": "Selector de colores {{value}}", "noColorLabel": "Selector crom\xE1tico. No se ha seleccionado un color." }, "UIButtonCollapser": { "dropdownLabel": "Acciones" }, "UIErrorMessage": { "error": { "title": "No encontramos lo que buscas." }, "notFound": { "title": "No todos los que deambulan est\xE1n perdidos." }, "badRequest": { "title": "Se produjo un problema al cargar esta p\xE1gina." }, "expired": { "title": "Lo sentimos." } }, "UIPanelNavigator": { "backButton": "Ir a la pantalla anterior" }, "UILoadingSpinner": { "busyText": "Cargando", "completedText": "Cargada" }, "UISideNav": { "navigationLandmark": "Secundario" }, "UISortTH": { "ascendingSort": "Orden ascendente. Presiona para cambiar a orden descendente.", "descendingSort": "Orden descendente. Presiona para cambiar a orden ascendente.", "pressToSort": "Presiona para ordenar." }, "autosizedTextInput": { "charactersRemaining": "{{value}} caracteres restantes" }, "time": { "today": "Hoy a las {{time}}", "yesterday": "Ayer a las {{time}}", "datetime": "{{date}} a la(s) {{time}}" }, "progress": { "percentComplete": "{{percent}} completo" }, "datePicker": { "dateSelected": "Se seleccion\xF3 {{date}}.", "noDateSelected": "No hay fecha seleccionada.", "dateBelowMin": "Debes elegir una fecha m\xE1s reciente", "dateAboveMax": "Debes elegir una fecha m\xE1s antigua", "invalidDate": "Fecha no v\xE1lida", "today": "Hoy", "clear": "Borrar", "placeholder": { "month": "MM", "day": "DD", "year": "AAAA" }, "nextMonth": "Mes siguiente", "prevMonth": "Mes anterior" }, "dateRange": { "startDate": "Inicio", "endDate": "Finalizaci\xF3n", "endDateBeforeStartDate": "La fecha de fin debe ser posterior a la fecha de inicio.", "startDateAfterEndDate": "La fecha de inicio debe ser anterior a la fecha de fin.", "to": "para" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "... y {{count}} m\xE1s.", "loadMore": "Cargar m\xE1s" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "A\xF1adir" }, "UIAvatarHoverlay": { "text": "Cambiar la foto" }, "UIChangeArrow": { "decrease": "Disminuci\xF3n de", "increase": "Aumento de" }, "UICopyInput": { "label": "Copiar", "title": "Copiar en el portapapeles", "tooltipCopied": "Copiado" }, "UIConfirm": { "defaultConfirm": "S\xED", "defaultReject": "No" }, "UICloseButton": { "label": "Cerrar" }, "UIDateRangePicker": { "rangeType": { "ALL": "Todo", "THIS_DAY": "Hoy", "LAST_DAY": "Ayer", "THIS_WEEK": "Esta semana", "LAST_WEEK": "Semana pasada", "THIS_MONTH": "Este mes", "LAST_MONTH": "Mes pasado", "LAST_THIRTY_DAYS": "\xDAltimos 30 d\xEDas", "LAST_THREE_MONTHS": "\xDAltimos 3 meses", "THIS_QUARTER": "Este trimestre", "LAST_QUARTER": "Trimestre pasado", "THIS_YEAR": "Este a\xF1o", "LAST_YEAR": "A\xF1o pasado", "CUSTOM": "Per\xEDodo personalizado" } }, "UIDropdownSelect": { "placeholder": "No has seleccionado ning\xFAn valor" }, "UIEditableControls": { "cancel": "Cancelar", "save": "Guardar" }, "UIExpandableText": { "collapseButtonText": "Ver menos", "expandButtonText": "Ver m\xE1s" }, "UIFileInput": { "defaultChangeLabel": "Cambiar archivo", "defaultSelectLabel": "Elegir archivo" }, "UIIconRating": { "ariaValueText": "{{value}} de {{maxValue}}" }, "UILink": { "externalTitle": "El enlace se abre en una ventana nueva" }, "UILoading": { "title": "Cargando\u2026" }, "UILockBadge": { "title": "Esta caracter\xEDstica est\xE1 bloqueada" }, "UIPaginator": { "label": "Paginaci\xF3n", "pageNumber": { "currentIndicator": "Est\xE1s actualmente en", "description": "P\xE1gina " }, "firstPage": { "label": "Primero", "description": "Primera p\xE1gina" }, "previousPage": { "label": "Anterior", "description": "P\xE1gina anterior" }, "nextPage": { "label": "Siguiente", "description": "P\xE1gina siguiente" }, "lastPage": { "label": "\xDAltima", "description": "\xDAltima p\xE1gina" } }, "UIPreviousButton": { "label": "Anterior" }, "UINextButton": { "label": "Siguiente" }, "UINumberRating": { "lowRangeLabel": "Muy en desacuerdo", "highRangeLabel": "Muy de acuerdo" }, "UISearchableSelectInput": { "placeholder": "Buscar" }, "UISearchInput": { "placeholder": "Buscar", "minimumSearchMessage": { "one": "Escribe 1 car\xE1cter m\xE1s", "other": "Escribe {{count}} caracteres m\xE1s", "many": "Escribe {{count}} de caracteres m\xE1s" }, "clearButton": "Borrar entrada" }, "UISelect": { "allOptionsSelected": "Todas las opciones est\xE1n seleccionadas", "createOption": "Crear opci\xF3n de \"{{label}}\"", "plusMore": "+ {{count}} m\xE1s", "andMore": "... y {{count}} m\xE1s.", "loadMore": "Cargar m\xE1s", "noResults": "No se encontraron resultados", "placeholder": "Buscar", "typeToSearch": "Escribe lo que deseas buscar" }, "UITable": { "selectableTableRow": { "toggleSelection": "Invertir selecci\xF3n de la fila" } }, "UITabs": { "moreDropdownLabel": "M\xE1s" }, "UITeaseNotification": { "optionsButtonTooltipText": "Mostrar opciones" }, "UITimePicker": { "placeholder": "Seleccionar una hora" }, "UIToggle": { "checkedLabel": "ACTIVADA", "uncheckedLabel": "DESACTIVADA" }, "UITypeahead": { "noMatchesFound": "No se encontraron coincidencias", "noOptions": "Ninguna" }, "UIWizard": { "back": "Anterior", "cancel": "Cancelar", "done": "Listo", "next": "Siguiente", "stepCount": "Paso {{stepNumber}} de {{stepCount}}" }, "XSSTooltip": { "explanation": "Este enlace ha sido desactivado por tu seguridad." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "es": "static-1.4543"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4543",
    "ar-eg": "static-1.4543",
    "bg": "static-1.4543",
    "bn": "static-1.4543",
    "ca-es": "static-1.4543",
    "cs": "static-1.4543",
    "da": "static-1.4543",
    "de": "static-1.4543",
    "el": "static-1.4543",
    "en-gb": "static-1.4543",
    "en": "static-1.4543",
    "es-mx": "static-1.4543",
    "es": "static-1.4543",
    "et": "static-1.4543",
    "fi": "static-1.4543",
    "fr-ca": "static-1.4543",
    "fr": "static-1.4543",
    "he-il": "static-1.4543",
    "hi": "static-1.4543",
    "hr": "static-1.4543",
    "hu": "static-1.4543",
    "id": "static-1.4543",
    "it": "static-1.4543",
    "ja": "static-1.4543",
    "ko": "static-1.4543",
    "lt": "static-1.4543",
    "ms": "static-1.4543",
    "nl": "static-1.4543",
    "no": "static-1.4543",
    "pl": "static-1.4543",
    "pt-br": "static-1.4543",
    "pt-pt": "static-1.4543",
    "ro": "static-1.4543",
    "ru": "static-1.4543",
    "sk": "static-1.4543",
    "sl": "static-1.4543",
    "sv": "static-1.4543",
    "th": "static-1.4543",
    "tl": "static-1.4543",
    "tr": "static-1.4543",
    "uk": "static-1.4543",
    "vi": "static-1.4543",
    "zh-cn": "static-1.4543",
    "zh-hk": "static-1.4543",
    "zh-tw": "static-1.4543"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:es', {version: 'static-1.4543'}); }
})();



(function() {
  var result = { translations: { "es": { "placeholder": "marcador de posici\xF3n" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "es": "static-3.6206"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6206",
    "ar-eg": "static-3.6206",
    "bg": "static-3.6206",
    "bn": "static-3.6206",
    "ca-es": "static-3.6206",
    "cs": "static-3.6206",
    "da": "static-3.6206",
    "de": "static-3.6206",
    "el": "static-3.6206",
    "en-gb": "static-3.6206",
    "en": "static-3.6206",
    "es-mx": "static-3.6206",
    "es": "static-3.6206",
    "et": "static-3.6206",
    "fi": "static-3.6206",
    "fr-ca": "static-3.6206",
    "fr": "static-3.6206",
    "he-il": "static-3.6206",
    "hi": "static-3.6206",
    "hr": "static-3.6206",
    "hu": "static-3.6206",
    "id": "static-3.6206",
    "it": "static-3.6206",
    "ja": "static-3.6206",
    "ko": "static-3.6206",
    "lt": "static-3.6206",
    "ms": "static-3.6206",
    "nl": "static-3.6206",
    "no": "static-3.6206",
    "pl": "static-3.6206",
    "pt-br": "static-3.6206",
    "pt-pt": "static-3.6206",
    "ro": "static-3.6206",
    "ru": "static-3.6206",
    "sk": "static-3.6206",
    "sl": "static-3.6206",
    "sv": "static-3.6206",
    "th": "static-3.6206",
    "tl": "static-3.6206",
    "tr": "static-3.6206",
    "uk": "static-3.6206",
    "vi": "static-3.6206",
    "zh-cn": "static-3.6206",
    "zh-hk": "static-3.6206",
    "zh-tw": "static-3.6206"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:es', {version: 'static-3.6206'}); }
})();



(function() {
  var result = { translations: { "es": { "app": { "htmlTitle": "IU de enlaces virales", "welcomeHome": "Hola, {{ firstName }}", "yourAppIsReady": "Tu aplicaci\xF3n est\xE1 lista", "aSecondPage": "Una segunda p\xE1gina para contener m\xE1s contenido.", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Llena esta p\xE1gina vac\xEDa con ", createElement( options, "Link", props.linkProps, "componentes" ), " en ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Crea tus propios formularios gratuitos</strong> para generar leads desde tu sitio web." }, "liveChat": { "linkCta": "<strong>Agrega live chat.</strong> Con\xE9ctate con los visitantes. Gratis.", "ariaLabel": "Agrega live chat. Con\xE9ctate con los visitantes. Gratis." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Agrega un chat en directo.</strong> Contacta con los visitantes de manera gratuita.", "ariaLabel": "[Int] Agrega un chat en directo. Contacta con los visitantes de manera gratuita." }, "meetings": { "linkCta": "<strong>Crea tu p\xE1gina de reserva de reuniones gratuita</strong> para programar reuniones de forma m\xE1s r\xE1pida." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "es": "static-1.3793"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.3793",
    "ar-eg": "static-1.3793",
    "bg": "static-1.3793",
    "bn": "static-1.3793",
    "ca-es": "static-1.3793",
    "cs": "static-1.3793",
    "da": "static-1.3793",
    "de": "static-1.3793",
    "el": "static-1.3793",
    "en-gb": "static-1.3793",
    "en": "static-1.3793",
    "es-mx": "static-1.3793",
    "es": "static-1.3793",
    "et": "static-1.3793",
    "fi": "static-1.3793",
    "fr-ca": "static-1.3793",
    "fr": "static-1.3793",
    "he-il": "static-1.3793",
    "hi": "static-1.3793",
    "hr": "static-1.3793",
    "hu": "static-1.3793",
    "id": "static-1.3793",
    "it": "static-1.3793",
    "ja": "static-1.3793",
    "ko": "static-1.3793",
    "lt": "static-1.3793",
    "ms": "static-1.3793",
    "nl": "static-1.3793",
    "no": "static-1.3793",
    "pl": "static-1.3793",
    "pt-br": "static-1.3793",
    "pt-pt": "static-1.3793",
    "ro": "static-1.3793",
    "ru": "static-1.3793",
    "sk": "static-1.3793",
    "sl": "static-1.3793",
    "sv": "static-1.3793",
    "th": "static-1.3793",
    "tl": "static-1.3793",
    "tr": "static-1.3793",
    "uk": "static-1.3793",
    "vi": "static-1.3793",
    "zh-cn": "static-1.3793",
    "zh-hk": "static-1.3793",
    "zh-tw": "static-1.3793"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:es', {version: 'static-1.3793'}); }
})();


